module.exports = __webpack_public_path__ + "img/36.4b984c1a.jpg";